type Credentials = {
  uid: string;
  accessToken: string;
  client: string;
};

export type UserData = {
  givenName?: string;
  familyName?: string;
  locale?: string;
  email?: string;
};

const parseCredentials = (credentials: Credentials) => {
  const { accessToken, ...rest } = credentials;
  return {
    ...rest,
    "access-token": accessToken,
  };
};
export const getCredentials = () => {
  const credentials = localStorage.getItem("auth");
  if (credentials) {
    return JSON.parse(credentials);
  }
  return {};
};
export const storeCredentials = (credentials: Credentials) => {
  // localStorage is a synchronous API, hence no need for using async/await here
  const oldCredentials = getCredentials();
  localStorage.setItem(
    "auth",
    JSON.stringify(
      parseCredentials({
        ...oldCredentials,
        ...credentials,
      })
    )
  );
};

export const getUserData = (): UserData | undefined => {
  const userData = localStorage.getItem("user");
  if (userData) {
    return JSON.parse(userData);
  }

  return undefined;
};
export const storeUserData = (userData: UserData) => {
  const oldUserData = getUserData();
  localStorage.setItem(
    "user",
    JSON.stringify({
      ...oldUserData,
      ...userData,
    })
  );
};

export const getLocale = () => getUserData()?.locale;

export const authenticate = (credentials: Credentials, userData: UserData) => {
  storeCredentials(credentials);
  storeUserData(userData);
};

export const logout = () => {
  localStorage.removeItem("auth");
  localStorage.removeItem("user");
  localStorage.removeItem("language");
  // trigger storage event
  window.dispatchEvent(
    new StorageEvent("storage", {
      key: "auth",
    })
  );
};

export const isAuthValid = (authString: string | undefined | null): boolean => {
  if (authString) {
    try {
      const auth = JSON.parse(authString);
      return auth.client && auth.uid && auth["access-token"];
    } catch (er) {
      console.error(er);
    }
  }
  return false;
};

export default authenticate;
